export default __webpack_public_path__ + "static/scam-latitude-protect-alert-6-881e2e1b37d13c62ccb886ad647e9347.webp";